/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceViewDetails {
    getFixupPrototypeFunction() { return ResourceViewDetails.fixupPrototype; }

    static newInstance(model: Partial<ResourceViewDetails>): ResourceViewDetails {
        let obj = Object.assign(new ResourceViewDetails(), model);
        ResourceViewDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceViewDetails>): ResourceViewDetails {
        if (!model) return null;
        return ResourceViewDetails.newInstance(<ResourceViewDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceViewDetails) {
        if (!obj) return;

        models.ResourceViewDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceViewDetails): boolean {
        Object.setPrototypeOf(obj, ResourceViewDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resource_details) {
            for (let val of this.resource_details) {
                models.ResourceDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Template/Policies Details that is scheduled to run
     */
    resource_details: Array<models.ResourceDetails>;

}
